<div class="city-dialog-header">
    <div class="city-dialog-header__icon" aria-hidden="true">
        <mat-icon>edit_location_alt</mat-icon>
    </div>

    <div class="city-dialog-header__content">
        <h2 mat-dialog-title class="city-dialog-title">
            {{ 'Update City' | translate }}
        </h2>
        <p>{{ 'Update the city information and its geographic coordinates.' | translate }}</p>
    </div>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="city-dialog-form">
    <div mat-dialog-content class="city-dialog-content">
        <section class="daxa-form-block">
            <div class="daxa-form-block__heading">
                <div class="daxa-form-block__icon">
                    <mat-icon>apartment</mat-icon>
                </div>
                <div>
                    <h3>{{ 'City information' | translate }}</h3>
                    <p>{{ 'Edit the basic details used across the platform.' | translate }}</p>
                </div>
            </div>

            <div class="field-stack">
                <mat-form-field>
                    <mat-label>{{ 'City name' | translate }}</mat-label>
                    <mat-icon matPrefix>location_city</mat-icon>
                    <input
                        matInput
                        formControlName="title"
                        [placeholder]="'City_example_placeholder' | translate"
                        autocomplete="off"
                    />
                    <mat-error *ngIf="form.controls.title.touched && form.controls.title.invalid">
                        {{ 'Required' | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{ 'Time zone Id' | translate }}</mat-label>
                    <mat-icon matPrefix>schedule</mat-icon>
                    <mat-select formControlName="timeZoneId" [placeholder]="'Select a time zone' | translate">
                        <mat-option *ngFor="let tz of timeZones" [value]="tz">{{ tz }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.controls.timeZoneId.touched && form.controls.timeZoneId.invalid">
                        {{ 'Required' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </section>

        <section class="daxa-form-block">
            <div class="daxa-form-block__heading">
                <div class="daxa-form-block__icon">
                    <mat-icon>my_location</mat-icon>
                </div>
                <div>
                    <h3>{{ 'Location coordinates' | translate }}</h3>
                    <p>{{ 'Update the exact latitude and longitude of the city.' | translate }}</p>
                </div>
            </div>

            <div class="map-picker">
                <div class="map-picker__info">
                    <div class="map-picker__icon" aria-hidden="true">
                        <mat-icon>map</mat-icon>
                    </div>
                    <div class="map-picker__copy">
                        <strong>{{ 'Choose location on map' | translate }}</strong>
                        <span>{{ 'Search an address, click on the map, or drag the marker to select the exact location.' | translate }}</span>
                        <div *ngIf="selectedAddress" class="map-picker__address">
                            <mat-icon>location_on</mat-icon>
                            <span>{{ selectedAddress }}</span>
                        </div>
                    </div>
                </div>

                <button
                    mat-stroked-button
                    type="button"
                    class="map-picker__button"
                    (click)="openMap()"
                    [disabled]="saving"
                >
                    <mat-icon>travel_explore</mat-icon>
                    <span>{{ 'Choose on map' | translate }}</span>
                </button>
            </div>

            <div class="coordinate-grid">
                <mat-form-field>
                    <mat-label>{{ 'Latitude' | translate }}</mat-label>
                    <mat-icon matPrefix>north</mat-icon>
                    <input
                        matInput
                        type="number"
                        inputmode="decimal"
                        step="any"
                        formControlName="latitude"
                        (input)="clearSelectedAddress()"
                        placeholder="55.6761"
                    />
                    <span matSuffix class="degree-suffix">°</span>
                    <mat-hint>-90 {{ 'to' | translate }} 90</mat-hint>
                    <mat-error *ngIf="form.controls.latitude.touched && form.controls.latitude.invalid">
                        {{ getLatitudeError() | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{ 'Longitude' | translate }}</mat-label>
                    <mat-icon matPrefix>east</mat-icon>
                    <input
                        matInput
                        type="number"
                        inputmode="decimal"
                        step="any"
                        formControlName="longitude"
                        (input)="clearSelectedAddress()"
                        placeholder="12.5683"
                    />
                    <span matSuffix class="degree-suffix">°</span>
                    <mat-hint>-180 {{ 'to' | translate }} 180</mat-hint>
                    <mat-error *ngIf="form.controls.longitude.touched && form.controls.longitude.invalid">
                        {{ getLongitudeError() | translate }}
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="coordinate-note">
                <mat-icon>info</mat-icon>
                <span>{{ 'Select the location from the map or enter latitude and longitude manually.' | translate }}</span>
            </div>
        </section>
    </div>

    <div mat-dialog-actions class="city-dialog-actions">
        <button mat-button type="button" class="cancel-button" (click)="close()" [disabled]="saving">
            {{ 'Cancel' | translate }}
        </button>

        <button
            mat-raised-button
            class="daxa submit-button"
            type="submit"
            cdkFocusInitial
            [disabled]="saving || form.invalid"
        >
            <ng-container *ngIf="!saving; else savingTemplate">
                <mat-icon>save</mat-icon>
                <span>{{ 'Save' | translate }}</span>
            </ng-container>

            <ng-template #savingTemplate>
                <span class="saving-state">
                    <mat-progress-spinner diameter="18" mode="indeterminate" strokeWidth="3"></mat-progress-spinner>
                    {{ 'Saving…' | translate }}
                </span>
            </ng-template>
        </button>
    </div>
</form>
